import { makeStyles } from '@material-ui/core/styles';
import icHelpCircle from '../../assets/images/svg/ic-help-circle.svg';
import Tooltip from '../shared/Tooltip';

const useStyles = makeStyles(
  {
    title: {
      display: 'flex',
      alignItems: 'center',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 20,
      lineHeight: '26px',
      color: '#2A394D',
      marginBottom: 36,
      '& > img': {
        marginLeft: 4,
      },
    },
  },
  {
    name: 'Header',
  },
);

const PageTitle = ({ title, tooltip }) => {
  const classes = useStyles();

  return (
    <div className={classes.title}>
      {title}
      {tooltip && (
        <Tooltip light placement="top" title={tooltip}>
          <img src={icHelpCircle} alt="plan is expired" />
        </Tooltip>
      )}
    </div>
  );
};

export default PageTitle;
